import { Injectable } from '@angular/core';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';


/**
 * ナビゲートサービス
 *
 * @export NavigateURLUtilService
 * @class NavigateURLUtilService
 */
@Injectable()
export class NavigateURLUtilService {

  /**
   * サフィックス（?YYYYMMDDHHNNSS)を返却
   *
   * @param {Object} [url=null] url:ナビゲートするURL
   * @returns {string}
   * @memberof NavigateURLUtilService
   */
  public getURLwithSuffixString(url: Object = null): string {
    let ret: string = PlessViewUtilsSub.formatedNowDate('YYYYMMDDhhmmss');
    if (url === null || url === '') {
      ret = '';
    } else if (String(url).indexOf('?') < 0) {
      ret = url + '?' + ret;
    } else {
      ret = url + '&' + ret;
    }
    return ret;
  }

  /**
   * 指定されたURLにナビゲートする
   *
   * @param request:リクエストオブジェクト
   * @param target:ターゲットウィンドウ文字列
   */
      // 項番2231 START 連合会管理NO.63対応
  // public navigateToURL(request: string, target: string = null): void {
  public navigateToURL(request: string, target: string = null, size: string): void {
    // 項番2231 END 連合会管理NO.63対応
    // request = this.getURLwithSuffixString(request);
    // 項番2231 START 連合会管理NO.63対応
    // window.open(request, target);
    window.open(request, target, size);
    // 項番2231 END 連合会管理NO.63対応
  }
}
